/** 本地模式用到的极小格式化工具。牌桌的完整格式化在 viewmodel 层，这里只做筹码数字。 */
import type { Chips } from '@poker/shared'

/**
 * 筹码显示。千分位用半角逗号而不是「万/k」缩写：
 * 下注决策要比较精确数值，缩写会让 12,400 和 12,800 看起来一样。
 */
export function formatChips(n: Chips): string {
  if (!Number.isFinite(n)) return '0'
  return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/gu, ',')
}
